<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form #editForm="ngForm" [windeDisableFormControls]="editForm.form" class="clr modal-window-content" name="editForm" novalidate>
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>Auto-connect</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div class="siklu-mat-dialog-body" matDialogContent>
        <div class="form-group row justify-content-center">
            <label class="col-5 col-form-label-sm" for="max-neighbors">Max Neighbors</label>
            <div class="col-6">
                <input
                        (input)="numNodesChanged()"
                        [(inputVal)]="historyService.logicalTopology.autoConnectOptions.num_nodes"
                        [(ngModel)]="historyService.logicalTopology.autoConnectOptions.num_nodes"
                        class="form-control form-control-sm"
                        id="max-neighbors"
                        max="50"
                        min="1"
                        name="max-neighbors"
                        step="1"
                        type="number"
                        windeNumberInputValidation
                />
            </div>
        </div>
        <div class="form-group row justify-content-center">
            <label class="col-5 col-form-label-sm" for="radius"
            >Auto-connect radius ({{ historyService.logicalTopology.productUnits }})</label
            >
            <div class="col-6">
                <input
                        [ngModel]="
                        historyService.logicalTopology.autoConnectOptions.radius | FeetConvert: historyService.logicalTopology.productUnits
                    "
                        class="form-control form-control-sm"
                        id="radius"
                        name="radius"
                        readonly
                        type="number"
                />
            </div>
        </div>
        <div *ngIf="layers?.length" class="form-group row justify-content-center">
            <label class="col-5 col-form-label-sm" for="layer-to-connect">Layer to connect</label>
            <div class="col-6">
                <select
                        (ngModelChange)="setRadiusForLayer($event)"
                        [(ngModel)]="historyService.logicalTopology.autoConnectOptions.layerIndex"
                        class="form-control form-control-sm"
                        id="layer-to-connect"
                        name="layer-to-connect"
                >
                    <option *ngFor="let layer of layers" [ngValue]="layer.key">{{ layer.value }}</option>
                </select>
            </div>
        </div>
        <div class="form-group row justify-content-center">
            <label class="col-5 col-form-label-sm" for="mode">Mode</label>
            <div class="col-6">
                <select
                        [(ngModel)]="historyService.logicalTopology.autoConnectOptions.pop_only"
                        class="form-control form-control-sm"
                        id="mode"
                        name="mode"
                >
                    <option [ngValue]="autoconnectModes.ANY_TO_ANY">Any-to-Any</option>
                    <option [ngValue]="autoconnectModes.ANY_TO_POP">All-to-PoP</option>
                    <option [ngValue]="autoconnectModes.ANY_TO_BU">Any-to-BU</option>
                </select>
            </div>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button
                (click)="runAutoconnect()"
                [disabled]="editForm.form.invalid || !historyService.isEditModeEnabled"
                id="run_autoconnect"
                windeGreen
        >
            Run
        </button>
    </div>
</form>
